import { useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "./axios";
import {
  EodPreviewRequest,
  EodFinalizeRequest,
  EodReportResponse,
} from "../types/eodTypes";

export const useEodPreview = () => {
  return useMutation({
    mutationKey: ["useEodPreview"],
    mutationFn: async (request: EodPreviewRequest) => {
      const { data } = await axiosInstance.post("/eod/preview", request);
      return data as EodReportResponse;
    },
  });
};

export const useFinalizeEod = () => {
  return useMutation({
    mutationKey: ["useFinalizeEod"],
    mutationFn: async (request: EodFinalizeRequest) => {
      const { data } = await axiosInstance.post("/eod/finalize", request);
      return data as EodReportResponse;
    },
  });
};

export const useGetFinalEodReport = ({
  branchId,
  counterId,
  businessDate,
  enabled = false,
}: {
  branchId: number;
  counterId?: number | null;
  businessDate: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ["useGetFinalEodReport", branchId, counterId, businessDate],
    queryFn: async () => {
      const { data } = await axiosInstance.get("/eod/report", {
        params: { branchId, counterId, businessDate },
      });
      return data as EodReportResponse;
    },
    enabled: enabled && !!branchId && !!businessDate,
    retry: false, // Do not retry on 404
  });
};

export const downloadEodPreviewPdf = async (
  request: EodPreviewRequest,
): Promise<Blob> => {
  const { data } = await axiosInstance.post("/eod/preview/export/pdf", request, {
    responseType: "blob",
  });
  return data;
};

export const downloadFinalEodPdf = async (params: {
  branchId: number;
  counterId?: number | null;
  businessDate: string;
}): Promise<Blob> => {
  const { data } = await axiosInstance.get("/eod/report/export/pdf", {
    params,
    responseType: "blob",
  });
  return data;
};

export const downloadEodPreviewExcel = async (
  request: EodPreviewRequest,
): Promise<Blob> => {
  const { data } = await axiosInstance.post("/eod/preview/export/excel", request, {
    responseType: "blob",
  });
  return data;
};

export const downloadFinalEodExcel = async (params: {
  branchId: number;
  counterId?: number | null;
  businessDate: string;
}): Promise<Blob> => {
  const { data } = await axiosInstance.get("/eod/report/export/excel", {
    params,
    responseType: "blob",
  });
  return data;
};
